import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const SwitcherButton = ({
  iconName,
  onClick,
  value,
  label,
  labelResponsive,
  isSelected,
  className,
  displayType,
}) => {
    const RadioSwitcher = () => (
        <span onClick={isSelected ? null : () => onClick(value)} className="radio">
          <input
              id={value}
              name="radio"
              type="radio"
              onChange={() => null}
              defaultChecked={isSelected}
          />
          <label htmlFor={value} className="radio-label">
            {label}{" "}
            {iconName ? (
              <Svg iconName={iconName} size="Small" className="ui-switcher__logo" />
            ) : null}
          </label>
        </span>
      );

    const BoxSwitcher = () => (
        <span
            className={`ui-switcher__btn ui-btn 
                ${className} ${isSelected ? 'ui-btn_primary' : 'ui-btn_secondary'
            }`}
            onClick={isSelected ? null : () => onClick(value)}
        >
            <span className="ui-switcher__title">{label}</span>
            <span className="ui-switcher__title_responsive">{labelResponsive}</span>
            {iconName && (
                <Svg iconName={iconName} size="Small" className="ui-switcher__logo" />
            )}
        </span>
      );


    switch (displayType) {
        case 'radio':
            return (<RadioSwitcher />);
        case 'box':
        default:
            return (<BoxSwitcher />);
    }
};

SwitcherButton.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    iconName: PropTypes.string,
    className: PropTypes.string,
    label: PropTypes.string.isRequired,
    labelResponsive: PropTypes.string,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    displayType: PropTypes.string,
};

export default SwitcherButton;



// WEBPACK FOOTER //
// ./src/client/components/SwitcherButton.js